import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApixuService {

  constructor(private http: HttpClient) { }

    getWeather(location) {
        return this.http.get(
            'http://api.weatherstack.com/current?access_key=ee3c8375eb029dc620670b18250b5721&query=' + location
        );
    }

}
